module.exports = __webpack_public_path__ + "img/slider_contact4.3fdc890a.jpg";